/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Equipment_Place_HomeInputs */

const en_us2_onboarding_equipment_place_home = /** @type {(inputs: Onboarding_Equipment_Place_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At home`)
};

const pt_br2_onboarding_equipment_place_home = /** @type {(inputs: Onboarding_Equipment_Place_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em casa`)
};

const es_419_onboarding_equipment_place_home = /** @type {(inputs: Onboarding_Equipment_Place_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En casa`)
};

const pt_pt2_onboarding_equipment_place_home = /** @type {(inputs: Onboarding_Equipment_Place_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em casa`)
};

const fr_fr2_onboarding_equipment_place_home = /** @type {(inputs: Onboarding_Equipment_Place_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À la maison`)
};

const de_de2_onboarding_equipment_place_home = /** @type {(inputs: Onboarding_Equipment_Place_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu Hause`)
};

const it_it2_onboarding_equipment_place_home = /** @type {(inputs: Onboarding_Equipment_Place_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A casa`)
};

/**
* | output |
* | --- |
* | "At home" |
*
* @param {Onboarding_Equipment_Place_HomeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_equipment_place_home = /** @type {((inputs?: Onboarding_Equipment_Place_HomeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Equipment_Place_HomeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_equipment_place_home(inputs)
	if (locale === "es-419") return es_419_onboarding_equipment_place_home(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_equipment_place_home(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_equipment_place_home(inputs)
	if (locale === "de-DE") return de_de2_onboarding_equipment_place_home(inputs)
	if (locale === "it-IT") return it_it2_onboarding_equipment_place_home(inputs)
	return en_us2_onboarding_equipment_place_home(inputs)
});
export { onboarding_equipment_place_home as "onboarding.equipment_place.home" }